import {create} from 'zustand';
import {SUMMARY_TABS} from '../constants/summary-tabs.constants';

interface ContractTabsSummaryState {
  activeTab: keyof typeof SUMMARY_TABS;

  changeContractTabsSummary: (_: unknown, activeTab: keyof typeof SUMMARY_TABS) => void;
  resetActiveTab: () => void;
}

export const useContractTabsSummaryStore = create<ContractTabsSummaryState>((set) => ({
  activeTab: SUMMARY_TABS.APPLICATIONS,

  changeContractTabsSummary: (_: unknown, activeTab: keyof typeof SUMMARY_TABS) => set({activeTab}),
  resetActiveTab: () => set({activeTab: SUMMARY_TABS.APPLICATIONS}),
}));

export const {changeContractTabsSummary, resetActiveTab} = useContractTabsSummaryStore.getState();
